const REFERENCE_ASSETS = {
    USD: 'usd',
    EUR: 'eur',
    BTC: 'btc',
    ETH: 'eth',
    FTM: 'ftm',
    MATIC: 'matic',
    XDAI: 'xdai',
    AVAX: 'avax',
    ONE: 'one',
    LINK: 'link',
    GOLD: 'gold',
    CRV: 'crv',
    CVX: 'cvx',
    SPELL: 'spell',
    WGLMR: 'wglmr',
    LDO: 'ldo',
    T: 't',
    CELO: 'celo',
    WKAVA: 'wkava',
    CRYPTO: 'crypto',
    OTHER: 'other',
};

const REFERENCE_ASSETS_PROXY = new Proxy(REFERENCE_ASSETS, {
    get: function(target, name) {
        if (
            typeof name === 'string' &&
            !(name in target) &&
            !name.startsWith('_') // Ignore "private" props
        ) {
            throw new Error(`Property "${name}" not found on object "REFERENCE_ASSETS"`);
        }

        return target[name];
    },
});

module.exports = REFERENCE_ASSETS_PROXY;
